<template>
  <Modal name="DELETE_PARTNER_MODAL" :title="title" actions>
    <template v-slot:body>
      <p class="mb-1">{{ $t('partner.hints.delete') }}</p>
      <v-card class="pa-5 mt-5 grey lighten-3" outlined>
        <v-progress-linear v-if="isLoading" indeterminate />
        <span v-else>
          {{ partner ? partner.name : '---' }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isLoading"
        class="mr-5"
        large
        text
      >
        {{ $t('partner.action.cancel') }}
      </v-btn>

      <v-btn
        @click="removePartner(partner.id)"
        :loading="isLoading"
        class="error"
        large
        dark
        text
      >
        {{ $t('partner.action.delete') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'PartnerDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['partner', 'isLoading']),
  },

  data() {
    return {
      title: this.$t('partner.action.delete'),
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['removePartner']),
  },
}
</script>
